import { render, staticRenderFns } from "./StoreName.vue?vue&type=template&id=2b6ad2da&scoped=true"
import script from "./StoreName.vue?vue&type=script&lang=js"
export * from "./StoreName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ad2da",
  null
  
)

export default component.exports